import React from 'react';
import { motion } from 'framer-motion';
export function G7CloudFooter() {
  return <motion.footer initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.5,
    delay: 0.7
  }} className="w-full border-t border-slate-200 bg-white mt-auto" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6" data-id="element-3">
          {/* Left: Brand + tagline */}
          <div data-id="element-4">
            <div className="flex items-center gap-2 mb-2" data-id="element-5">
              <img className="h-6 w-auto opacity-90 grayscale hover:grayscale-0 transition-all duration-300" src="https://cdn.magicpatterns.com/uploads/1UMrPmCeSmFJKDo4KBzyQi/g7cloud-logo-2026-300x75.png" alt="G7Cloud" data-id="element-6" />
            </div>
            <p className="text-xs text-slate-500" data-id="element-7">
              Reliable infrastructure for web hosting providers
            </p>
          </div>

          {/* Right: Links */}
          <nav className="flex flex-wrap items-center gap-6" aria-label="Footer navigation" data-id="element-8">
            <a href="https://g7cloud.com/about-us/" className="text-xs font-medium text-slate-500 hover:text-g7-orange transition-colors" data-id="element-9">
              About
            </a>
            <a href="https://g7cloud.com/contact/" className="text-xs font-medium text-slate-500 hover:text-g7-orange transition-colors" data-id="element-10">
              Contact
            </a>
            <a href="#" className="text-xs font-medium text-slate-500 hover:text-g7-orange transition-colors" data-id="element-11">
              Status
            </a>
            <a href="https://g7cloud.com/terms-conditions/" className="text-xs font-medium text-slate-500 hover:text-g7-orange transition-colors" data-id="element-12">
              Terms
            </a>
          </nav>
        </div>

        <div className="mt-6 pt-5 border-t border-slate-100 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-13">
          <p className="text-xs text-slate-400" data-id="element-14">
            © {new Date().getFullYear()} G7Cloud. All rights reserved.
          </p>
        </div>
      </div>
    </motion.footer>;
}